import { useMemo } from "react";
import { useQuery, UseQueryOptions } from "react-query";

import { Common } from "@secondcloset/types";

import { fetchFacilityIndex, Facility } from "../../../api/common/facility";

type UseFacilityIndexOptions = UseQueryOptions<Facility[], Error, Facility[], string[]>;
export const useFacilityIndex = (options?: UseFacilityIndexOptions) =>
  useQuery(["facilityIndex"], fetchFacilityIndex, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    select: (response) => response.filter((f) => f.name !== "unknown"),
    ...options,
  });

export const useFacilityLookup = () => {
  const facilities = useFacilityIndex();
  return facilities.data?.reduce((acc, cur) => ({ ...acc, [cur.name]: cur }), {}) as Record<Facility["name"], Facility>;
};

/**
 * Return value for v1 and v2 are slightly different
 * This hook is for backwards compatibility
 */
export const useFacilitiesV2ToV1Adaptor = (facilities: Facility[]) =>
  useMemo(() => {
    return facilities.map((facility) => {
      const { address, ...rest } = facility;
      return { ...rest, address: { table: address } };
    }) as unknown as Common.Facility<"V1">[];
  }, [facilities]);
